import React, { useEffect } from 'react';

import Footer from '../../components/layout/Footer';
import Map from './components/Map';

import HeaderMeta from 'components/headerMeta/HeaderMeta';
import '../../assets/style/itemStyle/common.scss';
import HubspotForm from './components/HubspotForm';
const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HeaderMeta type="contactUs" />
      <div className="contact-us-container">
        <div className="banner">
          <img
            src={require('../../assets/imgs/webp/contact-us-banner.webp').default}
            alt="contact us banner"
          />
        </div>
        <div className="contact-us-content">
          <h3>Ask Us Anything!</h3>
          <HubspotForm
            scriptSrc="https://js.hsforms.net/forms/v2.js"
            formId="832533e3-946f-43a3-8bad-2e7762e918bb"
          />
          <div className="info-bottom">
            <ul>
              <li>Airacer Inc.</li>
              <li>
                <p>
                  28-07 Jackson Ave,
                  <br />
                  Long Island City, NY 11101
                </p>
              </li>
              <li>
                <p>
                  Email:
                  <br />
                  charter@airacer.com
                </p>
                <p>
                  Tel:
                  <br />
                  +1 800-213-5051
                </p>
              </li>
            </ul>
            <Map />
          </div>
        </div>
        <img
          src={require('../../assets/imgs/webp/contact-popup.webp').default}
          alt="contact popup"
          style={{ display: 'none' }}
        />
      </div>
      <Footer />
    </>
  );
};

export default ContactUs;
